import { useState, useEffect } from 'react';
import axios from 'axios';

export default function ResetPasswordForm() {
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedEmail, setSelectedEmail] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [message , setMessage ] = useState(null)
    const AUTO_HIDE_MESSAGE_DELAY = 3000;

    useEffect(() => {
        fetchUsers();
    }, []);


    const getAuthHeaders = () => {
        const token = localStorage.getItem("jwtToken");
        return { Authorization: `${token}` };
    };

    const fetchUsers = async () => {
        try {
            setLoading(true);

            const [clientResponse, translatorResponse] = await Promise.all([
                axios.get('https://api.waraq.co/waraq/api/v1/admin/users?role=CLIENT', {
                    headers: getAuthHeaders()
                }),
                axios.get('https://api.waraq.co/waraq/api/v1/admin/users?role=TRANSLATOR', {
                    headers: getAuthHeaders()
                })
            ]);

            const clientData = clientResponse.data;
            const translatorData = translatorResponse.data;

            const mergedUsers = [
                ...(clientData.data || []),
                ...(translatorData.data || [])
            ];

            setUsers(mergedUsers);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch users');
            setLoading(false);
            console.error('Error fetching users:', err);
        }
    };

    const handleEmailChange = async (e) => {
        const email = e.target.value;
        setSelectedEmail(email);
    
        const user = users.find(u => u.email === email);
        if (!user) return;
        setSelectedUserId(user.id);

    
     
    };
    

    const handleUpdatePassword = async () => {
        if (!selectedUserId) {
            alert('Please select a user');
            return;
        }

        try {
            await axios.post(
                `https://api.waraq.co/waraq/api/v1/admin/users/reset-password`,
                { userId: selectedUserId },
                { headers: getAuthHeaders() }
            );
            // setSelectedUserId(user.id);

            setSelectedUserId('')
            setMessage('Rest password successfully ')
            setTimeout(() => setMessage(''), AUTO_HIDE_MESSAGE_DELAY);
            setTimeout(() => {
                window.location.reload();
              }, 3000);
    
        } catch (error) {
            console.error('Error resetting password for user:', error);
        }
    };

    const SuccessMessage = ({ message }) => {
        if (!message) return null;
        return <div className="popup-message">{message}</div>;
      };

      
    return (
        <>
        
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '75vh',
            }}
        >
            <div
                style={{
                    background: 'white',
                    padding: '20px',
                    borderRadius: '8px',
                    width: '400px',
                    boxShadow: '0 0 25px 8px rgba(0, 0, 0, 0.15)'
                }}
            >
                <h2 style={{ marginBottom: '20px' }}>Reset Password</h2>

                {loading ? (
                    <p>Loading users...</p>
                ) : error ? (
                    <p style={{ color: 'red' }}>{error}</p>
                ) : (
                    <div style={{ marginBottom: '20px' }}>
                        {/* <label 
              htmlFor="userSelect" 
              style={{ 
                display: 'block', 
                marginBottom: '8px',
                fontWeight: '500'
              }}
            >
              Select User Email
            </label> */}
                        <select
                            id="userSelect"
                            value={selectedEmail}
                            onChange={handleEmailChange}
                            style={{
                                width: '100%',
                                padding: '10px',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                fontSize: '14px',
                                cursor: 'pointer'
                            }}
                        >
                            <option value="">Select a user </option>
                            {users.map((user) => (
                                <option key={user.id} value={user.email}>
                                    {user.email} ({user.role})
                                </option>
                            ))}
                        </select>

                        {/* {selectedUserId && (
                            <p style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
                                Selected User ID: <strong>{selectedUserId}</strong>
                            </p>
                        )} */}
                    </div>
                )}

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button
                        onClick={handleUpdatePassword}
                        disabled={!selectedUserId}
                        style={{
                            padding: '8px 16px',
                            border: 'none',
                            borderRadius: '4px',
                            background: selectedUserId ? '#3F302F' : '#ccc',
                            color: 'white',
                            cursor: selectedUserId ? 'pointer' : 'not-allowed',
                        }}
                    >
                        Reset Password
                    </button>
                </div>
            </div>
        </div>

        <SuccessMessage message={message} />

        </>
     
    );
}
